import { isGlobalAdmin } from "@/helpers/permissions/users";

import store from "@/store";
import UserDashboard from "@/views/Dashboard.vue";

export default [
  {
    path: "/",
    name: "login",
    beforeEnter(to, from, next) {
      if (!store.state.user) {
        next("/login");
        return;
      }

      if (isGlobalAdmin(store.state.user)) {
        next("/admin/dashboard");
        return;
      }

      next("/app");
    },
  },
  {
    path: "/app",
    name: "dashboard",
    component: UserDashboard,
    meta: {
      auth: true,
      title: "titles.dashboard",
    },
  },
];
